<template>
  <div>
    <!-- DIALOGO NUEVA SOLICITUD -->
    <el-dialog
      title="Crear Solicitud"
      :visible.sync="showDialogVisible"
      width="80%"
      v-loading.fullscreen.lock="fullscreenLoading"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-form
        :model="model"
        :rules="rules"
        ref="newRequestForm"
        label-width="150px"
        class="demo-ruleForm"
        label-position="top"
        enctype="multipart/fomr-data"
      >
        <div style="justify-content: center; display: flex">
          <div style="margin-right: 75px">
            <el-form-item label="Cliente" prop="ClientName">
              <el-input v-model="model.ClientName" disabled />
            </el-form-item>

            <el-form-item label="Empresa" prop="CompanyCode">
              <el-input v-model="model.CompanyCode" disabled />
            </el-form-item>
          </div>

          <div style="margin-right: 75px">
            <el-form-item label="RNC / Cedula" prop="CustomerIdentification">
              <el-input v-model="model.CustomerIdentification" disabled />
            </el-form-item>

            <el-form-item label="Tipo de solicitud" prop="ServiceRequestTypeId">
              <el-select
                v-model="model.ServiceRequestTypeName"
                placeholder="Tipo de solicitud"
                clearable
                filterable
                no-data-text="FAVOR ELEGIR EL PRODUCTO PRIMERO"
                @change="ShowHideContractLines"
              >
                <el-option
                  v-for="(item, index) in RequestTypes"
                  :key="index"
                  :label="item.ServiceName"
                  :value="item"
                  :disabled="item.disabled"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <div style="margin-right: 75px">
            <el-form-item label="Producto" prop="ProductId">
              <el-select
                clearable
                filterable
                default-first-option
                v-model="model.ProductId"
                placeholder="Producto"
                @change="handleProductChange"
              >
                <el-option
                  v-for="item in list_products"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Inciada por" prop="InitiatedBy">
              <el-select
                v-model="model.InitiatedBy"
                placeholder="Inciada por"
                clearable
                filterable
              >
                <el-option
                  v-for="item in InitiatedByItems"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>

          <div style="margin-right: 75px">
            <el-form-item
              label="Contrato"
              prop="ContractCode"
              v-if="
                model.ServiceRequestTypeId == 2 ||
                model.ServiceRequestTypeId == 3 ||
                model.ServiceRequestTypeId == 4
              "
            >
              <el-select
                v-model="model.ContractCode"
                placeholder="Número de Contrato"
                clearable
                filterable
                @change="LineContractSelect"
              >
                <el-option
                  v-for="item in headContractNo"
                  :key="item.ContractCode"
                  :value="item.ContractCode"
                  :label="item.ContractCode"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label="Precio del Servicio"
              v-if="model.ServiceRequestTypeId == 2"
              style="width: 100px"
            >
              <el-input-number v-model="model.InstallationPrice" />
            </el-form-item>
          </div>

          <div style="margin-right: 75px">
            <!--
            <el-form-item label="Inciada por" prop="InitiatedBy">
              <el-select
                v-model="model.InitiatedBy"
                placeholder="Inciada por"
                clearable
                filterable
              >
                <el-option
                  v-for="item in InitiatedByItems"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
-->
            <el-form-item label="Contacto">
              <el-select
                v-model="model.ContactCode"
                placeholder="Contacto"
                clearable
                filterable
              >
                <!-- <el-option
              v-for="(item, index) in list_contact"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option> -->
                <el-option
                  v-for="item in contactByCust"
                  :key="item.ContactCode"
                  :value="item.ContactCode"
                  :label="item.Name"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Comentario" prop="Comments">
              <el-input v-model="model.Comments" type="textarea"></el-input>
            </el-form-item>
          </div>
        </div>
        <el-row class="flex justify-center">
          <el-alert
            v-if="HasPendingInvoices && AreRequestBlocked"
            title="El Cliente tiene facturas pendientes, por lo que no se le podrá crear algunos tipos de solicitudes."
            type="error"
            :closable="false"
            show-icon
            center
          >
            {{ pendingInvoicesAlertTitle }}
          </el-alert>
        </el-row>
        <div v-if="haveDevices">
          <h4>Selección de Equipos</h4>
          <div style="margin-bottom: 10px">
            <el-button @click="addNewDevice">Agregar dispotivo</el-button>
          </div>
          <el-table
            border
            :data="model.DeviceTypes"
            empty-text="No ha seleccionado dispotivo"
          >
            <el-table-column type="index"></el-table-column>
            <el-table-column label="Tipo de Dispotivo" prop="DeviceTypeId">
              <template slot-scope="scope">
                <el-select v-model="scope.row.DeviceTypeId">
                  <el-option
                    v-for="(item, index) in DeviceTypesHardCode"
                    :key="index"
                    :label="item.Description"
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="Cantidad" prop="Quantity">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.Quantity" :min="0" />
              </template>
            </el-table-column>

            <el-table-column label="" width="90" align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index)"
                  ><i class="el-icon-close"></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="justify-content: center; display: flex; margin-top: 25px">
          <el-form-item
            :label="Adjunto"
            prop="AdjuntoID"
            style="margin-right: 25px"
          >
            <!-- <input type="file" id="file" name="file" /> -->
            <el-upload
              ref="upload"
              class="upload-demo"
              drag
              :action="URL_API_UPLOAD"
              :multiple="false"
              :limit="1"
              :headers="headers"
              :auto-upload="true"
              :on-exceed="handleExceed"
              :data="dataToUpload"
              :on-success="handleUploadSuccess"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Suelta tu archivo aquí o <em>haz clic para cargar</em>
              </div>
            </el-upload>
            <!-- <input name="img" type="file" /> -->
          </el-form-item>
          <el-form-item label="Más detalles" prop="moreDetails">
            <quill-editor
              ref="myQuillEditor"
              v-model="model.moreDetails"
              style="height: 275px; width: 1000px; margin-bottom: 150px"
            >
            </quill-editor>
          </el-form-item>
        </div>
        <!-- <template v-if="Uninstallation">
          <div style="margin-bottom: 10px">
            <el-button @click="addNewContractLine"
              >Agregar Línea de Contrato</el-button
            >
          </div>
          <el-table
            border
            :data="model.ContractLines"
            empty-text="No ha seleccionado la línea de contrato"
          >
            <el-table-column type="index"></el-table-column>
            <el-table-column label="Línea" prop="ContractCode">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.ContractCode"
                  placeholder="Número de Contrato"
                  clearable
                  filterable
                  @change="LineContractSelect"
                >
                  <el-option
                    v-for="item in headContractNo"
                    :key="item.ContractCode"
                    :value="item.ContractCode"
                    :label="item.ContractCode"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="Descripción" prop="LineNo">
              <template slot-scope="scope">
                <el-select
                  v-if="ContractLinesSelect"
                  v-model="scope.row.LineNo"
                  placeholder="Líneas del contrato"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in LineContract"
                    :key="item.ContractLineNo"
                    :value="item.ContractLineNo"
                    :label="item.Description"
                  >
                  </el-option>
                </el-select>

                <el-input
                  placeholder="MARCA - MODELO - O FICHA"
                  v-model="scope.row.Desc"
                  v-if="ContractLinesInput"
                />
              </template>
            </el-table-column>
            <el-table-column label="" width="90" align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleContractLine(scope.$index)"
                  ><i class="el-icon-close"></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </template> -->
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitForm('newRequestForm')"
          v-loading="buttonLoading"
          :disabled="buttonLoading"
          >Crear</el-button
        >
        <el-button @click="resetForm('newRequestForm')">Close</el-button>
      </span>
    </el-dialog>
    <!-- DIALOGO SOLICITUDES PENDIENTE POR CALIFICAR -->
    <el-dialog
      title="Solicitudes pendiente por calificar"
      :visible.sync="FormVisible"
      width="65%"
      :close-on-click-modal="false"
      :append-to-body="true"
      :show-close="false"
    >
      <el-container>
        <el-main>
          <el-row>
            <el-col>
              <RabbeyTable3 :data="items" :columns="columns" />
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import { mapGetters } from "vuex";
//import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import SLAClolorStatus from "@/components/functionals/SLAClolorStatus";
import QualifyServiceRequest from "@/components/functionals/QualifyServiceRequest.vue";
import { BASE_API_URL } from "@/const.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
// /api/serviceRequests/UploadFile
export default {
  components: {
    RabbeyTable3,
    quillEditor
  },
  name: "DialogNewRequestForm",
  props: {
    Desinstalacion: {
      type: Boolean,
      default: false,
      required: false
    },
    Adjunto: {
      type: String,
      default: "Adjunto",
      required: false
    },
    CurrentClient: {
      type: String,
      default: "",
      required: false
    },
    AreRequestBlocked: {
      tyoe: Boolean,
      default: true,
      required: false
    }
  },
  data() {
    return {
      fullscreenLoading: false,
      items: [],
      FormVisible: false,
      Uninstallation: false, // show and hide template
      ContractLinesSelect: false, // show and hide select option
      ContractLinesInput: false, // show and hide select option
      ResponseFileName: "",
      contactByCust: "",
      headContractNo: "",
      LineContract: "",
      fileName: "",
      URL_API_UPLOAD: BASE_API_URL + "/api/gallery/uploadanyFile", // se cambio "/api/serviceRequests/FileUploading",
      dataToUpload: {
        id: 0
      },
      showDialogVisible: false,
      fileList: [],
      InitiatedByItems: [
        {
          label: "Tennos Business",
          value: 0,
          IsEnable: true
        },
        {
          label: "Cliente / Contacto",
          value: 1,
          IsEnable: true
        }
      ],
      model: {
        ClientName: "",
        ClientCode: "",
        CustomerIdentification: "",
        CompanyCode: "",
        Comments: "",
        ServiceRequestTypeName: "",
        ServiceRequestTypeId: "",
        ProductId: "",
        InitiatedBy: 0,
        ContactCode: "",
        DeviceTypes: [],
        ContractLines: [],
        ContractCode: "",
        InstallationPrice: 0,
        moreDetails: ""
      },
      model2: {
        ClientName: "",
        ClientCode: "",
        CustomerIdentification: "",
        CompanyCode: "",
        Comments: "",
        ServiceRequestTypeId: "",
        ProductId: "",
        InitiatedBy: 0,
        ContactCode: "",
        DeviceTypes: []
      },
      rules: {
        ServiceRequestTypeId: [{ required: true }],
        ProductId: [{ required: true }],
        InitiatedBy: [{ required: true }],
        ContactCode: [{ required: true }],
        Comments: [{ required: true }],
        ClientCode: [{ required: true }],
        ClientName: [{ required: true }],
        CustomerIdentification: [{ required: true }],
        CompanyCode: [{ required: true }],
        moreDetails: [{ required: false }]
        //AdjuntoID: [{ required: this.Desinstalacion }]
      },
      clientCode: "",
      currentClient: {},
      HasPendingInvoices: false,
      pendingInvoicesAlertTitle: "",
      headers: {
        Authorization: `Bearer ${this.$store.state.auth.token}`
      },
      uploadSuccess: false,
      companyId: this.$store.state.user.user.CompanySelected,

      DeviceTypesHardCode: [],
      RequestTypes: [],
      RequestTypeLoading: false,
      serviceRequestTypeValidator: 1,
      columns: [
        {
          prop: "serviceRequestID",
          label: "Calificame",
          minWidth: 100,
          sortable: false,
          formatter: QualifyServiceRequest
        },
        {
          prop: "serviceRequestID",
          label: "NO",
          width: 80,
          sortable: true,
          formatter: SLAClolorStatus
        },
        {
          prop: "Customer",
          label: "Cliente",
          minWidth: 300,
          formatter: (row) => {
            if (
              row.Customer === "" ||
              row.Customer === null ||
              row.Customer === undefined
            ) {
              return row.Customer;
            }
            return row.Customer;
          }
        },
        {
          prop: "serviceTypeIdDescription",
          label: "Tipo de Solictud",
          sortable: true,
          // formatter: row => {
          //   return row.ServiceRequestType ? row.ServiceRequestType.Description : "";
          // },
          minWidth: 200
        },
        {
          prop: "CreatedBy",
          label: "Creada Por",
          formatter: ImagePerson,
          minWidth: 250,
          sortable: true
        },
        {
          prop: "Tecnico",
          label: "Tecnico",
          minWidth: 250,
          formatter: ImagePerson,
          sortable: true
        },
        {
          prop: "Description",
          label: "Comentario",
          minWidth: 190,
          sortable: true
        }
      ],
      haveDevices: false,
      buttonLoading: false
    };
  },
  /*
  updated() {
    if (this.Desinstalacion === true) {
      console.this.RequestTypes = this.RequestTypes.filter(
        (request) => request.ServiceName === "Desinstalación"
      );
    }
  },
  */
  computed: {
    ...mapGetters({
      list_contact: "contact/list_to_select",
      list_types_to_select: "request_types/list_to_select",
      list_products: "products/list_products"
    })
  },
  methods: {
    async submitForm(formName) {
      //await this.$refs.upload.submit();

      if (this.model.ContractCode == null) {
        if (
          this.model.ServiceRequestTypeId == 2 ||
          this.model.ServiceRequestTypeId == 3
        ) {
          this.$message({
            type: "danger",
            message: "Debe seleccionar un número de contrato."
          });
          return;
        }
      } else if (this.model.ContractCode == null) {
        this.$message({
          type: "danger",
          message: "Debe seleccionar un número de contrato."
        });
        return;
      } else if (
        this.$refs["newRequestForm"].model.ContractLines == null &&
        this.model.ServiceRequestTypeId == 2
      ) {
        this.$message({
          type: "danger",
          message: "Digite datos del vehiculo en la Descipción."
        });
        return;
      }
      // else if (
      //   this.$refs["newRequestForm"].model.ContractLines[0].LineNo == null &&
      //   this.model.ServiceRequestTypeId == 3
      // ) {
      //   this.$message({
      //     type: "warning",
      //     message: "Debe seleccionar la línea  de contrato"
      //   });
      //   return;
      // }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.buttonLoading = true;
          const { UserID, CompanySelected } = this.currentUser;

          const new_request = {
            ...this.model,
            AttachmentFileName: this.ResponseFileName,
            ServiceIsFree: true,
            Target: 0,
            UserId: UserID,
            CompanyCode: CompanySelected,
            ContactName: "",
            ContactEmail: ""
          };
          this.$store
            .dispatch("technical_support/create_request", new_request)
            .then((resp) => {
              this.showDialogVisible = false;
              this.dataToUpload.id = resp.data.Id;
              //this.$refs.upload.submit();
              this.$message({
                type: "success",
                message: "Solicitud creada!"
              });
              this.$refs["newRequestForm"].resetFields();
              this.model.ServiceRequestTypeName = "";
              this.haveDevices = false;
              this.model.Comments = "";
            })
            .catch((error) => {
              console.error(error);
            })
            .finally(() => {
              this.buttonLoading = false;
              this.$refs.upload.clearFiles();
              this.resetForm("newRequestForm");
            });
          this.$emit("Formsubmitted");
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      if (formName == "newRequestForm") {
        this.model.ContactCode = "";
        this.model.ServiceRequestTypeName = "";
      }
      this.showDialogVisible = false;
      this.$refs.upload.clearFiles();
      this.$refs[formName].resetFields();
    },
    handleClose(done) {
      this.model.DeviceTypes = [];
      this.model.ContractLines = [];
      this.model.ContractCode = "";
      this.model.InstallationPrice = 0;
      this.model.ServiceRequestTypeName = "";
      this.showDialogVisible = false;
      this.$refs.upload.clearFiles();
      this.$refs["newRequestForm"].resetFields();
      done();
    },
    async GetPendingInvoicesQuantity(clientCode) {
      await this.$http
        .get(`/api/invoices/InvoicePendingCount?CustomerCode=${clientCode}`)
        .then((resp) => {
          if (resp.data > 0) {
            this.HasPendingInvoices = true;
            this.$message({
              type: "warning",
              message: `El cliente tiene ${resp.data} factura(s) pendiente(s).`
            });
          }
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    async show(clientCode, currentClient) {
      await this.GetPendingInvoicesQuantity(clientCode ?? String(clientCode));

      this.model = this.model2;
      this.clientCode = clientCode ?? String(clientCode);
      this.currentClient = currentClient;
      this.model.ClientName = currentClient.Name ?? currentClient.Nombre;
      this.model.ClientCode = clientCode ?? String(clientCode);
      this.model.CustomerIdentification =
        currentClient.VatRegistrationNumber ?? "";
      this.model.CompanyCode = currentClient.CompanyId ?? this.currentCompany;
      this.model.DeviceTypes = [];
      this.model.ContractLines = [];
      this.showDialogVisible = true;
      this.getcontactByCust();
      this.headContractSelect();
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `El límite es 1, haz seleccionado ${files.length + fileList.length}`
      );
    },
    addNewDevice() {
      this.model.DeviceTypes.push({ DeviceTypeId: null, Quantity: null });
    },
    handleDelete(index) {
      this.model.DeviceTypes.splice(index, 1);
    },
    addNewContractLine() {
      this.model.ContractLines.push({
        ContractCode: null,
        LineNo: null,
        Desc: null
      });
    },
    handleContractLine(index) {
      this.model.ContractLines.splice(index, 1);
    },
    getcontactByCust() {
      this.$http
        .get(
          `/api/serviceRequests/GetContactByCust?companyCode=${this.companyId}&customerCode=${this.clientCode}`
        )
        .then((resp) => {
          const contacts = resp.data.map((i) => {
            return { ContactCode: i.Id, Name: i.FullName };
          });
          this.contactByCust = contacts;
          // this.$alert(IsoDocs, "Result");
          // this.$alert(resp.data, "Result");
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    headContractSelect() {
      this.$http
        .get(
          `/api/serviceRequests/headContract?ClientCode=${this.clientCode}&CompanyCode=${this.companyId}`
        )
        .then((resp) => {
          const contracts = resp.data.map((i) => {
            return { ContractCode: i.No_Contrato, Name: i.Nombre };
          });
          if (this.Desinstalacion === true) {
            //this.model.ContractCode = contracts[0]
            this.headContractNo = contracts;
          } else {
            this.headContractNo = contracts;
          }
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    LineContractSelect(val) {
      //this.$alert(val, "Result Contract");
      this.$http
        .get(
          `/api/serviceRequests/LineContract?contractNo=${val}&CompanyCode=${this.companyId}`
        )
        .then((resp) => {
          //this.$alert(resp.data, 'Result Line Contract');
          const contracts = resp.data.map((i) => {
            return { ContractLineNo: i.LineNo, Description: i.Descripcion };
          });
          this.LineContract = contracts;
          //this.$alert(this.headContractNo, "Result");
          // this.$alert(resp.data, "Result");
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    ShowHideContractLines(val) {
      this.model.ServiceRequestTypeName = val.ServiceName;
      this.model.ServiceRequestTypeId = val.ServiceId;
      this.haveDevices = val.CanHaveDevices;

      const getValType = typeof val.ServiceId;
      if (getValType === "number") {
        if (val.ServiceId == 3 || val.ServiceId == 2) {
          // Uninstallation
          this.Uninstallation = true;
          if (val.ServiceId == 2) {
            this.ContractLinesSelect = false;
            this.model.LineNo = 0;
            this.ContractLinesInput = true;
          } else {
            this.ContractLinesSelect = true;
            this.ContractLinesInput = false;
          }
        } else {
          this.Uninstallation = false;
        }
      } else {
        this.Uninstallation = false;
        this.RequestTypes = [];
      }
    },
    handleUploadSuccess(response) {
      this.ResponseFileName = response[0].Url;
    },
    // PendingServiceRequestByContact(val) {
    //const getValType = typeof val;

    // if (val > 0) {
    //   this.fullscreenLoading = true;
    //   this.$http
    //     .get(
    //       `/api/serviceRequests/PendingServiceRequestByContact?id=${val}&CompanyCode=${this.companyId}`
    //     )
    //     .then((resp) => {
    //       if (resp.data != "") {
    //         this.openCalendarDialog();
    //         this.items = resp.data;
    //       }
    //     })
    //     .catch((err) => {
    //       this.$alert(err.message, err.name, {
    //         type: "error"
    //       });
    //     })
    //     .finally(() => (this.fullscreenLoading = false));
    // } //fin if condition
    // },
    // openCalendarDialog() {
    //   this.FormVisible = true;
    // },
    getProducts(filter) {
      var deviceListLength = this.DeviceTypesHardCode.length;
      this.$http.get("/api/deviceTypes").then((resp) => {
        this.DeviceTypesHardCode = resp.data.Items.filter(
          (product) => product.FixedAssetType == filter
        );
        //si hay un cambio en la cantidad de dispositivos entonces limpia la tabla. Solo deberia pasar cuando haya cambio de producto de GPS a TERMINAL o viceversa
        if (deviceListLength != this.DeviceTypesHardCode.length) {
          this.model.DeviceTypes = [];
        }
      });
    },

    handleProductChange(product) {
      this.RequestTypeLoading = true;
      this.$http
        .get(
          `/api/serviceRequests/GetRequestTypesByProduct?productId=${product}`
        )
        .then((resp) => {
          if (this.Desinstalacion === true) {
            this.RequestTypes = resp.data.filter(
              (request) => request.ServiceName === "Desinstalación"
            );
            this.RequestTypeLoading = false;
            //this.model.ServiceRequestTypeName = "Desinstalación"
            //this.model.ServiceRequestTypeId = 2;
            //this.ShowHideContractLines()
          } else {
            if (this.HasPendingInvoices && this.AreRequestBlocked) {
              const ServiceRequestsTypesIdsToDisable = [
                1, 2, 3, 4, 5, 7, 9, 10, 11, 12, 13, 17, 18, 19, 20, 21, 22, 23,
                24, 28, 176, 375, 376, 377, 378, 379, 380, 387
              ];
              this.pendingInvoicesAlertTitle = resp.data
                .filter((pi) =>
                  ServiceRequestsTypesIdsToDisable.includes(pi.ServiceId)
                )
                .map((pi) => pi.ServiceName)
                .toString();

              this.RequestTypes = resp.data.map((item) => {
                if (ServiceRequestsTypesIdsToDisable.includes(item.ServiceId)) {
                  item.disabled = true;
                }
                return item;
              });
              this.RequestTypeLoading = false;
            } else {
              this.RequestTypes = resp.data;
              this.RequestTypeLoading = false;
            }
          }
        });
      var filter = product == 2 ? 1 : 0; //si el producto es magytrack (2) entonces traeme los equipos GPS (1) sino TERMINAL (0)
      this.getProducts(filter);
    }
  }
};
</script>

<style></style>
